import { ResponsiveImage } from '~/graphql/fragments'

export const queryArticles = /* GraphQL */ `
  ${ResponsiveImage}

  query Articles(
    $locale: SiteLocale
    $first: IntType = 100
    $skip: IntType
    $allInCategory: [ItemId]
    $notInSlug: [String]
    $slug: String
    $publishTranslation: BooleanType = true
  ) {
    _allArticlesMeta(
      locale: $locale
      filter: {
        category: { allIn: $allInCategory }
        publishTranslation: { eq: $publishTranslation }
        AND: [{ slug: { eq: $slug } }, { slug: { notIn: $notInSlug } }]
      }
    ) {
      count
    }
    allArticles(
      locale: $locale
      first: $first
      skip: $skip
      filter: {
        category: { allIn: $allInCategory }
        publishTranslation: { eq: $publishTranslation }
        AND: [{ slug: { eq: $slug } }, { slug: { notIn: $notInSlug } }]
      }
      orderBy: _firstPublishedAt_DESC
    ) {
      __typename
      _modelApiKey
      id
      category {
        _modelApiKey
        __typename
        id
        name
        slug
      }
      excerpt
      image {
        alt
        url
        width
        height
        responsiveImage(
          imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "16:9", w: 448 }
        ) {
          ...ResponsiveImage
        }
      }
      title
      slug
      publishTranslation
    }
  }
`
